import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";

import Breadcrumb from "../../components/Breadcrumb";
import FormOne from "../../components/HmgMain/HmgMainCreate/FormOne";

import { Steps } from "antd";
const { Step } = Steps;

const solutionsRelatedToHMG = ['myDocs', 'Compliance', 'ULP', 'QMS', 'Settings App']

class HmgMainCreate extends Component {
  formOneFormRef = React.createRef();
  state = {
    current: 0,
    create: true,
    select: null,
    selectData: null,
  };

  async componentDidMount() {
    if (!this.props.api.hmgMainGetData) {
      await this.props.hmgMainGet();
    }
    if (!this.props.api.solutionsGetData) {
      await this.props.solutionsGet();
    }
    await this.props.userListGet();

  }

  excludeReset = () => {
    const fieldsToExclude = ['hmg_name_1'];
    const fieldValues = this.formOneFormRef.current.getFieldsValue();
    const fieldsToReset = Object.keys(fieldValues).filter(
      fieldName => !fieldsToExclude.includes(fieldName)
    );
    this.formOneFormRef.current.resetFields(fieldsToReset);
  };

  generateEntityID(hmg) {
    let number = 700001;
    while (hmg.some(hmg => hmg.is_entityid === number)) {
      number++;
    }
    return number;
  }

  formOneOnFinish = async (values) => {
    if (this.state.create) {
      if (await this.props.hmgMainCreate(values)) {
        await this.props.hmgMainGet();
        this.formOneFormRef.current.resetFields();
        this.setState({ current: 0 });
      }
    } else {
      if (await this.props.hmgMainUpdate(values)) {
        await this.props.hmgMainGet();
        await this.props.hmgGet();
        this.formOneFormRef.current.resetFields();
        this.setState({ current: 0, create: true });
      }
    }
  };

  autoCompleteOneChangeFunction = async (value) => {
    if (value === undefined) {
      value = "";
    }

    const result = this.props.api.hmgMainGetData.data.find(
      (e) => e.hmg_name.toUpperCase() === value.toUpperCase()
    );
    if (result) {
      await this.setState({ create: false, selectData: result });

      let initialValue = null;
      if (this.state.selectData) {
        initialValue = this.state.selectData;
      }

      this.formOneFormRef.current.setFieldsValue({
        _id: initialValue && initialValue._id ? initialValue._id : "",
        hmg_name:
          initialValue && initialValue.hmg_name
            ? initialValue.hmg_name
            : "",
        solutions:
          initialValue && initialValue.solutions_ids
            ? initialValue.solutions_ids
            : [],
        is_entityid:
          initialValue && initialValue.is_entityid
            ? initialValue.is_entityid
            : "",
        corp_address:
          initialValue && initialValue.corp_address
            ? initialValue.corp_address
            : "",
        corp_city:
          initialValue && initialValue.corp_city
            ? initialValue.corp_city
            : "",
        country:
          initialValue && initialValue.country ? initialValue.country : null,
        state: initialValue && initialValue.state ? initialValue.state : null,
        corp_zip:
          initialValue && initialValue.corp_zip
            ? initialValue.corp_zip
            : "",
        corp_contact_name:
          initialValue && initialValue.corp_contact_name
            ? initialValue.corp_contact_name
            : "",
        corp_position_title:
          initialValue && initialValue.corp_position_title
            ? initialValue.corp_position_title
            : "",
        corp_office_phone:
          initialValue && initialValue.corp_office_phone
            ? initialValue.corp_office_phone
            : "",
        corp_work_cell:
          initialValue && initialValue.corp_work_cell
            ? initialValue.corp_work_cell
            : "",
        corp_email:
          initialValue && initialValue.corp_email
            ? initialValue.corp_email
            : "",
        smart_scan_type:
          initialValue && initialValue.smart_scan_type
            ? initialValue.smart_scan_type
            : undefined,
        split_by_sub_header:
            initialValue && initialValue.split_by_sub_header
              ? initialValue.split_by_sub_header
              : "0",
        mdo_mgmtgroupemail:
          initialValue && initialValue.mdo_mgmtgroupemail
            ? initialValue.mdo_mgmtgroupemail
            : "",
        mdo_mgmtgroupemailpassword:
          initialValue && initialValue.mdo_mgmtgroupemailpassword
            ? initialValue.mdo_mgmtgroupemailpassword
            : "",
        hmg_22:
          initialValue && initialValue.hmg_22 ? initialValue.hmg_22 : false,
        myp_id:
          initialValue && initialValue.myp_id ? initialValue.myp_id : null,
        myp_create_or_update:
          initialValue && initialValue.myp_create_or_update ? "1" : "0",
        myp_corporate_user:
          initialValue && initialValue.myp_corporate_user
            ? initialValue.myp_corporate_user
            : null,
        mwf: initialValue && initialValue.mwf ? initialValue.mwf : false,
        annotation:
          initialValue && initialValue.annotation
            ? initialValue.annotation
            : false,
      });
    } else {
      this.setState({ create: true, selectData: null });
      this.excludeReset();
      this.formOneFormRef.current.setFieldsValue({
        hmg_name: value,
      });
    }
  };

  autoCompleteOneSelect = async (value) => {
    await this.autoCompleteOneChangeFunction(value);
  };

  autoCompleteOneChange = (value) => {
    this.autoCompleteOneChangeFunction(value);
  };

  next = async () => {
    try {
      await this.formOneFormRef.current.validateFields();
      const current = this.state.current + 1;
      this.setState({ current });
    } catch (e) {
      if (this.state.current === 0) {
        const stepOneFields = ['hmg_name_1', 'hmg_name', 'is_entityid', 'myp_create_or_update', 'myp_corporate_user'];
        const stepOneErrors = e.errorFields.filter(
          errors => errors.name.some(fieldName => stepOneFields.includes(fieldName))
        );
        if (stepOneErrors.length > 0) {
          return
        } else {
          const current = this.state.current + 1;
          this.setState({ current });
        }
      }
    }
  };

  prev = () => {
    const current = this.state.current - 1;
    this.setState({ current });
  };

  render() {
    const { current } = this.state;

    const steps = [
      {
        title: "GENERAL INFORMATION",
        content: "First-content",
      },

      {
        title: "CORPORATE INFORMATION",
        content: "Second-content",
      },
    ];

    return (
      <div>
        <div className="container_aa">
          <h3>Hotel Management Group Create and Update</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              {
                path: "hmg-manager",
                breadcrumbName: "Hotel Management Group Create and Update",
              },
            ]}
          />
        </div>

        <div className="container_ab">
          <div className="container_style_2">
            <div>
              <Steps current={current}>
                {steps.map((item) => (
                  <Step key={item.title} title={item.title} />
                ))}
              </Steps>

              <div style={{ marginBottom: 20 }}></div>

              <div className="steps-content">
                {this.props.api.hmgMainGetData &&
                  this.props.api.solutionsGetData &&
                  this.props.api.userListGetData ? (
                  <FormOne
                    formRef={this.formOneFormRef}
                    onFinish={this.formOneOnFinish}
                    hmgMainGetData={this.props.api.hmgMainGetData.data}
                    userListGetData={this.props.api.userListGetData.data}
                    solutionsGetData={this.props.api.solutionsGetData.data}
                    autoCompleteOneChange={this.autoCompleteOneChange}
                    autoCompleteOneSelect={this.autoCompleteOneSelect}
                    createStatus={this.state.create}
                    current={current}
                    next={this.next}
                    prev={this.prev}
                    steps={steps}
                    initialValue={this.state.selectData}
                    solutionsRelatedToHMG={solutionsRelatedToHMG}
                    generateEntityID={this.generateEntityID}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hmgMainGet: () => dispatch(actions.hmgMainGet()),
  hmgGet: () => dispatch(actions.hmgGet()),
  userListGet: () => dispatch(actions.userListGet()),

  solutionsGet: () => dispatch(actions.solutionsGet()),
  hmgMainCreate: (data) => dispatch(actions.hmgMainCreate(data)),
  hmgMainUpdate: (data) => dispatch(actions.hmgMainUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HmgMainCreate);
